import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'glamor'
import colors from '../../style/colors'
import { fontSize, fontWeight } from '../../style/sizes'
import { mediaMaxWidth, SMALL_SCREEN_BREAKPOINT } from '../../style/mixins'
import RightArrow from '../rightArrow'

const CSS = {
  main: css({
    backgroundColor: colors.navy,
    color: colors.white,
    border: 'none',
    fontSize: fontSize.medium,
    lineHeight: fontSize.medium,
    fontWeight: fontWeight.bold,
    textTransform: 'uppercase',
    borderRadius: '100px',
    height: '50px',
    width: '155px',
    transition: 'background-color .2s',
    [mediaMaxWidth(SMALL_SCREEN_BREAKPOINT)]: {
      height: '45px'
    },
    ' > span': {
      marginRight: '15px'
    },
    ' > svg': {
      transition: 'transform .2s'
    },
    ':hover': {
      backgroundColor: colors.darkBlue,
      ' > svg': {
        transform: 'translateX(5px)'
      }
    }
  })
}

class SubscribeButton extends React.Component {
  render () {
    const { onClick, backgroundColor, hoverBackgroundColor, showArrow, overrideStyle } = this.props

    const style = overrideStyle || css(CSS.main, {
      backgroundColor,
      ':hover': {
        backgroundColor: hoverBackgroundColor
      }
    })

    return (
      <button type='submit' value='Submit' name='subscribe' id='mc-embedded-subscribe' onClick={onClick} className='button' {...style}>
        <span>Submit</span> {showArrow && <RightArrow />}
      </button>
    )
  }
}

SubscribeButton.propTypes = {
  backgroundColor: PropTypes.string,
  hoverBackgroundColor: PropTypes.string,
  overrideStyle: PropTypes.object,
  showArrow: PropTypes.bool,
  onClick: PropTypes.func
}

SubscribeButton.defaultProps = {
  backgroundColor: colors.navy,
  hoverBackgroundColor: colors.darkBlue,
  showArrow: true
}

export default SubscribeButton



// WEBPACK FOOTER //
// ./src/components/subscribeButton/index.js